import { useColorMode } from '@chakra-ui/react';

import { Icon } from '$/components/common/Icon';
import { Switch } from '$/components/common/Switch';

export const ThemeSwitcher = () => {
  const { colorMode, toggleColorMode } = useColorMode();
  const isLightMode = colorMode === 'light';

  return (
    <Switch
      checked={isLightMode}
      onChange={toggleColorMode}
      knob={
        isLightMode ? (
          <Icon icon='light_mode' h='full' w='full' />
        ) : (
          <Icon icon='dark_mode' h='full' w='full' />
        )
      }
    />
  );
};
